define(function(require, exports, module) {
    return module.exports = window.HotBox;
});


// WEBPACK FOOTER //
// ./src/kityminder-editor/hotbox.js